<template>
  <div>
    <slot name="trigger">
      <ValidationProvider :rules="rules" v-slot="{ validate, errors }">
        <div style="position: relative">
          <b-field :label="label" :type="{ 'is-danger': errors[0] }">
            <b-input
              type="text"
              :value="displayValue"
              @click.native="openOptionModal"
              @input="validate"
              class="valueDisplay"
              :icon="displayIcon"
            />
            <p class="help is-danger" v-if="errors[0] && showError">
              {{ errors[0] }}
            </p>
          </b-field>
          <b-icon icon="angle-down" size="is-medium" class="is-icon-right" />
        </div>
      </ValidationProvider>
    </slot>

    <b-modal
      v-model="optionModalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      @after-enter="$emit('modalShown')"
      @after-leave="showError = true"
    >
      <template #default="props">
        <div
          class="modal-card has-background-white"
          style="height: calc(100vh - 40px)"
        >
          <header class="modal-card-head has-background-white">
            <b-input
              v-model="dataSearch"
              type="search"
              icon="search"
              style="width: 100%"
              ref="dataSearch"
            />
          </header>
          <section class="modal-card-body">
            <slot
              name="options"
              :searchResult="filteredData"
              :updateModel="emitValue"
              :close="props.close"
            >
              <div v-if="filteredData.length">
                <b-field v-for="item in filteredData" :key="item.id">
                  <b-radio
                    v-model="radioModel"
                    :native-value="item.id"
                    @input="
                      emitValue($event);
                      props.close();
                    "
                  >
                    {{ item.name }}
                  </b-radio>
                </b-field>
              </div>
              <p v-else>Not found.</p>
            </slot>
          </section>
          <footer class="modal-card-foot has-background-white">
            <slot name="footer"></slot>
          </footer>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import helper from "@/functions/helper";

export default {
  name: "BSelectModalWithValidation",
  props: {
    rules: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    data: {
      type: Array,
      default: () => []
    },
    displayValue: {
      type: String,
      required: false
    },
    displayIcon: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      radioModel: this.value,
      optionModalOpen: false,
      dataSearch: "",
      showError: false
    };
  },
  computed: {
    filteredData() {
      const dataCopy = [...this.data];

      if (typeof dataCopy[0] === "string") {
        return dataCopy.filter(item => item.includes(this.dataSearch));
      }

      dataCopy.sort((a, b) => {
        const x = a.name.toLowerCase();
        const y = b.name.toLowerCase();

        if (x < y) {
          return -1;
        }

        if (x > y) {
          return 1;
        }

        return 0;
      });

      return helper.search(dataCopy, ["name"], this.dataSearch);
    }
  },
  methods: {
    openOptionModal() {
      this.dataSearch = "";
      this.optionModalOpen = true;
      this.$nextTick(() => {
        this.$refs.dataSearch.focus();
      });
    },
    emitValue(data) {
      this.$emit("input", data);
    }
  }
};
</script>

<style>
.valueDisplay input.input {
  cursor: pointer;
  pointer-events: all;
}
.is-icon-right {
  background-color: white;
  color: #ac8856;
  position: absolute;
  top: 35px;
  right: 5px;
  z-index: 35;
}
.valueDisplay.control.has-icons-left .icon {
  color: #4c4c4c;
}
</style>
